export default __webpack_public_path__ + "static/media/5.22f38c60.webp";